import { getCapabilities } from './capabilities.api';
import { hydrateFromCaps, applyGranularFallbacks } from './hydratePermissions';
import { nrAction, nrAttribute } from './newRelicHelper';

export const SET_CAPABILITIES = 'SET_CAPABILITIES';
export const SET_CAPABILITIES_STATUS = 'SET_CAPABILITIES_STATUS';

export type CapabilityStatus = 'idle' | 'loading' | 'ready' | 'error';

interface CapabilityState {
  caps: string[];
  status: CapabilityStatus;
}

const initialState: CapabilityState = { caps: [], status: 'idle' };

export const capabilitiesReducer = (
  state: CapabilityState = initialState,
  action: { type: string; data?: any } = { type: '' },
): CapabilityState => {
  switch (action.type) {
    case SET_CAPABILITIES:
      return { ...state, caps: action.data, status: 'ready' };
    case SET_CAPABILITIES_STATUS:
      return { ...state, status: action.data };
    default:
      return state;
  }
};

const isV2Enabled = (masterData: any): boolean =>
  !!masterData?.ops_dashboard_config?.parts_to_show?.use_permissions_v2;

export const loadCapabilitiesAndHydrate =
  (masterData: any) => async (dispatch): Promise<any> => {
    if (!isV2Enabled(masterData)) {
      applyGranularFallbacks(masterData);
      return masterData;
    }
    dispatch({ type: SET_CAPABILITIES_STATUS, data: 'loading' });
    const startedAt = Date.now();
    try {
      const caps = await getCapabilities();
      if (!caps) {
        dispatch({ type: SET_CAPABILITIES_STATUS, data: 'error' });
        nrAction('capabilities_fallback', {
          latencyMs: Date.now() - startedAt,
          reason: 'fetch_failed',
        });
        return masterData;
      }
      dispatch({ type: SET_CAPABILITIES, data: caps });
      nrAttribute('permissions_v2', true);
      nrAction('capabilities_fetch', {
        status: 'ok',
        count: caps.length,
        latencyMs: Date.now() - startedAt,
      });
      return hydrateFromCaps(masterData, caps);
    } catch (error) {
      dispatch({ type: SET_CAPABILITIES_STATUS, data: 'error' });
      nrAction('capabilities_fallback', {
        latencyMs: Date.now() - startedAt,
        error: String(error),
      });
      return masterData;
    }
  };
